<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{'general.loading' | translate}}...</p>
</ngx-spinner>
<div class="col-12">
    <h4 class="title-color">{{'breadcrumb.notification-approvers' | translate}}</h4>
    <hr>
    <fieldset *ngxPermissionsExcept="['Expired']">   
        <legend class="h6">
            {{'setting.notification_approved_prompt' | translate}}<br>
            <label class="radio-inline">
                <input id="Y" type="radio" name="optradio" value="1" (click)="approveNotis(true)" [(ngModel)]="appNotis['option']">&nbsp; {{'general.yes' | translate}}
            </label>&nbsp;
            <label class="radio-inline">
                <input id="N" type="radio" name="optradio" value="0" (click)="approveNotis(false)" [(ngModel)]="appNotis['option']">&nbsp; No
            </label>
        </legend>
    </fieldset>
    <ng-template [ngxPermissionsOnly]="['Expired']">
        <fieldset>   
            <legend class="h6">
                {{'setting.notification_approved_prompt' | translate}}<br>
                <label class="radio-inline">
                    <input [disabled]="true" id="Y" type="radio" name="optradio" value="1" (click)="approveNotis(true)" [(ngModel)]="appNotis['option']">&nbsp; {{'general.yes' | translate}}
                </label>&nbsp;
                <label class="radio-inline">
                    <input [disabled]="true" id="N" type="radio" name="optradio" value="0" (click)="approveNotis(false)" [(ngModel)]="appNotis['option']">&nbsp; No
                </label>
            </legend>
        </fieldset>
    </ng-template>
    <br>
    <div id="enable_approval" hidden>
        <mat-tab-group #tabs (selectedIndexChange)="tabChanged($event)">
            <mat-tab label="{{'setting.approvers' | translate}}" aria-selected="true">
                <ng-template matTabContent>
                    <div class="row m-2">
                        <div class="col-12 tabs">
                            <div class="d-flex flex-row bd-highlight float-right">
                                <div class="bd-highlight button-group pr-2">
                                    <button *ngxPermissionsExcept="['Activate','Expired','SecurityAgent','Supervisor']" class="btn btn-red btn-h-red" title="{{ 'setting.remove_approvers' | translate }}" (click)="removeApprovers()"> {{ 'setting.remove_approvers' | translate}} </button>
                                </div>
                                <div class="bd-highlight pl-2 pr-2">
                                    <!--Role filter-->
                                    <span>{{'roles.role' | translate}}</span><br>
                                    <div ngbDropdown class="d-inline-block w-100">
                                        <button class="btn btn-filter-size btn-outline-secondary bg-white w-100 text-dark"
                                                title="{{ 'roles.'+roleFilterApprovers | translate }}" id="role" ngbDropdownToggle>
                                            {{ 'roles.'+roleFilterApprovers | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="role">
                                            <button ngbDropdownItem (click)="changeRoleApproversLabel(role)"
                                                    title="{{ 'roles.'+role | translate }}" *ngFor="let role of rolesApprovers">
                                                {{ role | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="bd-highlight pl-2 pr-2">
                                    <!--Active/Inactive filter-->
                                    <span>{{'general.active_inactive' | translate}}</span><br>
                                    <div ngbDropdown class="d-inline-block w-100">
                                        <button class="btn btn-filter-size btn-outline-secondary bg-white w-100 text-dark"
                                            title="{{ 'general.'+statusFilter.toLowerCase() | translate }}" id="status" ngbDropdownToggle>
                                            {{ 'general.'+statusFilter.toLowerCase() | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="status">
                                            <button ngbDropdownItem (click)="changeStatusFilterLabel(status)" 
                                                title="{{ 'general.'+status.toLowerCase() | translate }}" *ngFor="let status of statuses">
                                                {{ 'general.'+status.toLowerCase() | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="bd-highlight pl-2 pr-2">
                                    <!--datasource filter-->
                                    <label for="filterApprovers" class="mb-0">{{'general.filter_name_email' | translate}}</label>
                                    <input id="filterApprovers" class="form-control border-secondary">
                                </div>
                                <div class="bd-highlight button-group">
                                    <!--clear filter-->
                                    <button class="btn remove-filter-btn ml-1" title="{{ 'general.clear_filter' | translate }}" (click)="clearFilterApprovers()">
                                        <i class="fa fa-times fa-sm" title="{{ 'general.clear_filter' | translate }}"></i>
                                    </button>
                                    <!--apply filter-->
                                    <button class="btn apply-filter-btn ml-1" title="{{ 'general.apply_filter' | translate }}" (click)="applyFilterApprovers()">
                                        <i class="fa fa-filter fa-xs" title="{{ 'general.apply_filter' | translate }}"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 tabs mb-4">
                        <table class="border-top" mat-table [dataSource]="dataSourceApprovers" matSort matSortActive="profileFirstName" matSortDirection="asc" #SortApprovers="matSort" (matSortChange)="sortDataApprovers($event)">
                            <ng-container matColumnDef="check">
                                <th mat-header-cell *matHeaderCellDef><label *ngIf="!expired" class="mr-2" for="checkAllApprovers">{{'general.select_all' | translate}}</label><input *ngIf="!expired" id="checkAllApprovers" type="checkbox" (click)="checkAllApprovers()"></th>
                                <td mat-cell *matCellDef="let approver"> <input *ngIf="!expired" name="selectedApprovers" [id]="approver.id" type="checkbox" (click)="selectApprovers(approver.id)" title="{{approver.profileFirstName}} {{approver.profileLastName}}" [checked]="(checkedApprovers.includes(approver.id.toString()))" [disabled]="(currentUserId==approver.id)||(approver.role=='Owner')"> </td>
                            </ng-container>
                            <ng-container matColumnDef="profileFirstName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.name' | translate}} </th>
                                <td mat-cell *matCellDef="let approver" [attr.role]="null"> {{approver.profileFirstName}} {{approver.profileLastName}}</td>
                            </ng-container>

                            <ng-container matColumnDef="userEmail">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.email' | translate}} </th>
                                <td mat-cell *matCellDef="let approver"> {{approver.email}} </td>
                            </ng-container>

                            <ng-container matColumnDef="userRole">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.role' | translate}} </th>
                                <td mat-cell *matCellDef="let approver"> {{approver.role | translate}} </td>
                            </ng-container>

                            <ng-container matColumnDef="userActive">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.active' | translate}} </th>
                                <td mat-cell *matCellDef="let approver"> 
                                    <i *ngIf="approver.active==0 || approver.active>3" class="fa fa-circle red-text" title="{{'general.inactive' | translate}}"><span class="info-act-inact">&nbsp;{{'general.inactive' | translate}}</span></i>
                                    <i *ngIf="approver.active>0 && approver.active<4" class="fa fa-circle green-text" title="{{'general.active' | translate}}"><span class="info-act-inact">&nbsp;{{'general.active' | translate}}</span></i>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsApprovers"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsApprovers;"></tr>
                        </table>
                        <mat-paginator #paginatorApprovers [length]="totalLengthApprovers" (page)="nextPageApprovers($event)" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="{{'user.users' | translate}}">
                <ng-template matTabContent>
                    <div class="row m-2">
                        <div class="col-12 tabs">
                            <div class="d-flex flex-row bd-highlight float-right">
                                <div class="bd-highlight button-group pr-2">
                                    <button *ngxPermissionsExcept="['Expired','SecurityAgent','Supervisor']" class="btn btn-blue btn-h-blue" title="{{ 'setting.assign_approvers' | translate }}" (click)="assignUsers()"> {{ 'setting.assign_approvers' | translate}} </button>
                                </div>
                                <div class="bd-highlight pl-2 pr-2">
                                    <!--Role filter-->
                                    <span>{{'roles.role' | translate}}</span><br>
                                    <div ngbDropdown class="d-inline-block w-100">
                                        <button class="btn btn-filter-size btn-outline-secondary bg-white w-100 text-dark"
                                                title="{{ 'roles.'+roleFilterUser | translate }}" id="roleList" ngbDropdownToggle>
                                            {{ 'roles.'+roleFilterUser | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="roleList">
                                            <button ngbDropdownItem (click)="changeRoleUserLabel(role)"
                                                    title="{{ 'roles.'+role | translate }}" *ngFor="let role of rolesUsers">
                                                {{ role | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="bd-highlight pl-2 pr-2">
                                    <!--datasource filter-->
                                    <label for="filterUsers" class="mb-0">{{'general.filter_name_email' | translate}}</label>
                                    <input id="filterUsers" class="form-control border-secondary">
                                </div>
                                <div class="bd-highlight button-group">
                                    <!--clear filter-->
                                    <button class="btn remove-filter-btn ml-1" title="{{ 'general.clear_filter' | translate }}" (click)="clearFilterUsers()">
                                        <i class="fa fa-times fa-sm" title="{{ 'general.clear_filter' | translate }}"></i>
                                    </button>
                                    <!--apply filter-->
                                    <button class="btn apply-filter-btn ml-1" title="{{ 'general.apply_filter' | translate }}" (click)="applyFilterUsers()">
                                        <i class="fa fa-filter fa-xs" title="{{ 'general.apply_filter' | translate }}"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 tabs mb-4">
                        <table class="border-top" mat-table [dataSource]="dataSourceUsers" matSortActive="profileFirstName" matSortDirection="asc" matSort (matSortChange)="sortDataUsers($event)">
                            <ng-container matColumnDef="check">
                                <th mat-header-cell *matHeaderCellDef> <label *ngIf="!expired" class="mr-2" for="checkAllUsers">{{'general.select_all' | translate}}</label><input *ngIf="!expired" id="checkAllUsers" type="checkbox" (click)="checkAllUsers()"> </th>
                                <td mat-cell *matCellDef="let user"> <input *ngIf="!expired" name="selectedUsers" title="{{user.profileFirstName}} {{user.profileLastName}}" [id]="user.id" type="checkbox" (click)="selectUser(user.id)" [checked]="(checkedUsers.includes(user.id.toString()))" [disabled]="(currentUserId==user.id)||(user.role=='Owner')"> </td>
                           </ng-container>
                            <ng-container matColumnDef="profileFirstName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.name' | translate}} </th>
                                <td mat-cell *matCellDef="let user"> {{user.profileFirstName}} {{user.profileLastName}}</td>
                            </ng-container>

                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.email' | translate}} </th>
                                <td mat-cell *matCellDef="let user"> {{user.email}} </td>
                            </ng-container>

                            <ng-container matColumnDef="role">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.role' | translate}} </th>
                                <td mat-cell *matCellDef="let user"> {{user.role | translate}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsUsers"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsUsers;"></tr>
                        </table>
                        <mat-paginator #paginatorUsers [length]="totalLengthUsers" (page)="nextPageUsers($event)" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

       